import { useCallback } from "react";
import { useFeedback } from "../contexts/FeedbackContext";
import { useIntercom } from "../providers/IntercomProvider";

/** The product's own support address. REACT_APP_SUPPORT_URL overrides it per deployment. */
export const DEFAULT_SUPPORT_URL = "mailto:product@magicbi.ai";
export const SUPPORT_URL = process.env.REACT_APP_SUPPORT_URL || DEFAULT_SUPPORT_URL;

/** The address to show for a mailto: link, else the link itself. */
export const supportAddress = (url: string): string => url.replace(/^mailto:/, "").split("?")[0];

/** Live chat, Send feedback and Email us: one source for the avatar menu and the top-bar Help menu. */
export const useHelpSupport = () => {
  const { showMessenger, available } = useIntercom();
  const { openFeedback } = useFeedback();
  const openLiveChat = useCallback(() => {
    if (available) showMessenger();
  }, [available, showMessenger]);
  return {
    liveChatAvailable: available,
    openLiveChat,
    openFeedback,
    supportUrl: SUPPORT_URL,
    supportAddress: supportAddress(SUPPORT_URL),
  };
};
